import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import "date-fns";
import PropTypes from "prop-types";
import { Header } from "../../../shared/components/header";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  titleSeparator: {
    width: "100%",
    height: "auto",
    margin: "50px 553.8px 1.5px 0.3px",
    fontSize: "18px",
    fontWeight: " normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.33",
    letterSpacing: " normal",
    textAlign: "left",
    color: "#353535",
  },
  marginWidget: {
    [theme.breakpoints.down("xs")]: {
      margin: "0 -36px",
    },
  },
}));

export const ParticipantFinancesPage = ({ navigation }) => {
  const classes = useStyles();

  return (
    <>
      <Header navigation={navigation}>
        <Grid container>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography component="h1" variant="h5" align="left">
              My Finances
            </Typography>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography
              variant="h4"
              color="textSecondary"
              align="left"
              className={classes.titleSeparator}
            >
              Investments
            </Typography>
            <hr />
          </Grid>
        </Grid>
      </Header>
    </>
  );
};

ParticipantFinancesPage.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

ParticipantFinancesPage.defaultProps = {
  navigation: [],
};
